<template>
  <router-view />
  <WhatsAppFloat v-if="showWhatsAppFloat" />
</template>

<script>
import { t } from '@/i18n'
import WhatsAppFloat from '@/components/WhatsAppFloat.vue'

const ROUTE_TITLE_KEYS = {
  Home: 'pageTitle.home',
  Contact: 'pageTitle.contact',
  About: 'pageTitle.about',
  Products: 'pageTitle.products',
  News: 'pageTitle.news'
}

export default {
  name: 'App',
  components: { WhatsAppFloat },
  computed: {
    showWhatsAppFloat() {
      const path = this.$route?.path || ''
      return !path.startsWith('/admin')
    }
  },
  watch: {
    currentLocale() {
      this.applyDocumentTitle()
    },
    '$route.name'() {
      this.applyDocumentTitle()
    }
  },
  methods: {
    applyDocumentTitle() {
      if (!this.showWhatsAppFloat) return
      const key = ROUTE_TITLE_KEYS[this.$route.name]
      if (key) {
        document.title = t(key)
      }
    }
  }
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
